import { useState } from "react";
import { useCart } from "@/contexts/CartContext";
import { X, Minus, Plus, Check } from "lucide-react";

export default function MealModal({ item, onClose }) {
  const cart = useCart();
  const [qty, setQty] = useState(1);
  const [selectedExtras, setSelectedExtras] = useState({});
  const [notes, setNotes] = useState("");

  const toggleExtra = (ex) => {
    setSelectedExtras((p) => ({ ...p, [ex.id]: p[ex.id] ? null : ex }));
  };

  const extrasList = Object.values(selectedExtras).filter(Boolean);
  const total = (item.price + extrasList.reduce((s, e) => s + e.price, 0)) * qty;

  const handleAdd = () => {
    cart.addItem(item, qty, extrasList, notes);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-up"
      onClick={onClose}
      data-testid="meal-modal">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl max-h-[92vh] overflow-y-auto flex flex-col shadow-2xl">
        <div className="relative">
          {item.image
            ? <img src={item.image} alt={item.name} className="w-full h-60 object-cover"/>
            : <div className="w-full h-60 bg-[var(--surface-alt)] flex items-center justify-center text-4xl">🍽</div>}
          <button onClick={onClose} className="absolute top-4 left-4 w-9 h-9 rounded-full bg-white/95 flex items-center justify-center text-[var(--text-primary)] hover:scale-110 transition" data-testid="modal-close">
            <X size={18}/>
          </button>
        </div>
        <div className="p-6 flex flex-col gap-5">
          <div>
            <h2 className="text-2xl font-black" style={{fontFamily:'Cairo'}}>{item.name}</h2>
            <p className="text-[var(--text-secondary)] mt-1">{item.description}</p>
            <div className="text-primary-brand font-black text-2xl mt-2" style={{fontFamily:'Cairo'}}>{item.price} د.ل</div>
          </div>

          {item.extras?.length > 0 && (
            <div>
              <h3 className="text-lg font-bold border-b border-[var(--border)] pb-2 mb-2" style={{fontFamily:'Cairo'}}>الإضافات</h3>
              {item.extras.map((ex) => (
                <label key={ex.id} className="flex items-center justify-between py-3 border-b border-[var(--border)]/50 last:border-0 cursor-pointer" data-testid={`extra-${ex.id}`}>
                  <div className="flex items-center gap-3">
                    <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition ${selectedExtras[ex.id] ? "bg-primary-brand border-primary-brand" : "border-[var(--border)]"}`}>
                      {selectedExtras[ex.id] && <Check size={14} className="text-white"/>}
                    </div>
                    <span className="font-bold">{ex.name}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-primary-brand font-bold">+{ex.price} د.ل</span>
                    <input type="checkbox" className="hidden" checked={!!selectedExtras[ex.id]} onChange={() => toggleExtra(ex)}/>
                  </div>
                </label>
              ))}
            </div>
          )}

          <div>
            <label className="text-sm font-bold block mb-2">ملاحظات خاصة</label>
            <textarea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)}
              placeholder="بدون بصل، بصلصة إضافية..."
              className="w-full px-4 py-2.5 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none resize-none text-right"
              data-testid="meal-notes"/>
          </div>

          <div className="flex items-center justify-between bg-[var(--surface-alt)] rounded-2xl p-3">
            <span className="font-bold">الكمية</span>
            <div className="flex items-center gap-3">
              <button onClick={() => setQty(Math.max(1, qty - 1))} className="w-9 h-9 rounded-full bg-white border border-[var(--border)] flex items-center justify-center hover:border-primary-brand" data-testid="qty-minus"><Minus size={16}/></button>
              <span className="font-black text-xl w-8 text-center" style={{fontFamily:'Cairo'}} data-testid="qty-value">{qty}</span>
              <button onClick={() => setQty(qty + 1)} className="w-9 h-9 rounded-full bg-primary-brand text-white flex items-center justify-center" data-testid="qty-plus"><Plus size={16}/></button>
            </div>
          </div>
        </div>

        <div className="sticky bottom-0 bg-white border-t border-[var(--border)] p-4 flex gap-3 items-center">
          <button onClick={handleAdd} className="flex-1 py-3.5 rounded-xl bg-primary-brand text-white font-bold text-base hover:opacity-95 talabya-shadow-float flex items-center justify-between px-5" data-testid="modal-add">
            <span>إضافة للسلة</span>
            <span className="font-black" style={{fontFamily:'Cairo'}}>{total.toFixed(2)} د.ل</span>
          </button>
        </div>
      </div>
    </div>
  );
}
